import axios from "axios";
import { mockData } from "./mockData";

// Debug flag - if enabled we'll log requests and return mock data
const LOCAL_DEV = false; // http://localhost:3000
const MOCK_DEBUG = false; // <MOCK>
const DEV_MODE = false; // https://calendar-877375085.development.catalystserverless.com/
const PROD_MODE = false; // https://calendar-877375085.catalystserverless.com/

if (DEV_MODE) console.warn("Dev mode enabled. This should be disabled in production!");
if (LOCAL_DEV) console.warn("Local development mode enabled: API requests will be directed to localhost:3000");
if (MOCK_DEBUG) console.warn("DEBUG Mode: Enabled - API requests will return mock data where available");
if (PROD_MODE) console.warn("Production test-mode enabled. This should not be in production!");

const axiosInstance = axios.create();

// Request interceptor
axiosInstance.interceptors.request.use(
    async (config) => {
        if (MOCK_DEBUG) {
            // Log request
            console.log("DEBUG Mode: Request", {
                url: config.url,
                method: config.method,
                data: config.data,
                params: config.params
            });

            // Check if we have mock data for this endpoint
            const mockResponse = mockData[config.url]?.[config.method?.toUpperCase()];

            if (mockResponse) {
                // Simulate network delay
                await new Promise((resolve) => setTimeout(resolve, 500));

                // Throw a special error that we'll catch in the response interceptor
                const error = new Error("Mock response");
                error.__MOCK_RESPONSE__ = true;
                error.data = mockResponse;
                throw error;
            }
        } else if (PROD_MODE) {
            config.baseURL = "https://calendar-877375085.catalystserverless.com/";
        } else if (DEV_MODE) {
            config.baseURL = "https://calendar-877375085.development.catalystserverless.com/";
        } else if (LOCAL_DEV) {
            config.baseURL = "http://localhost:3000";
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Check if this is our mock response
        if (error.__MOCK_RESPONSE__) {
            console.log("DEBUG Mode: Returning mock data", error.data);
            return Promise.resolve({ data: error.data });
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
